import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as shareLinksApi from "@api/share-links.api";
import type { ShareLink } from "@/types";

interface ShareLinksState {
  shareLinks: ShareLink[];
  loading: boolean;
}

const initialState: ShareLinksState = {
  shareLinks: [],
  loading: false,
};

export const fetchShareLinks = createAsyncThunk("shareLinks/fetchShareLinks", async () => {
  return await shareLinksApi.getShareLinks();
});

export const createShareLink = createAsyncThunk(
  "shareLinks/createShareLink",
  async (dto: {
    fileIds: string[];
    password?: string;
    expiresAt?: string;
    maxDownloads?: number;
  }) => {
    return await shareLinksApi.createShareLink(dto);
  },
);

export const deactivateShareLink = createAsyncThunk(
  "shareLinks/deactivateShareLink",
  async (id: string) => {
    await shareLinksApi.deactivateShareLink(id);
    return id;
  },
);

const shareLinksSlice = createSlice({
  name: "shareLinks",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchShareLinks.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchShareLinks.fulfilled, (state, action) => {
        state.shareLinks = action.payload;
        state.loading = false;
      })
      .addCase(fetchShareLinks.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createShareLink.fulfilled, (state, action) => {
        state.shareLinks = [action.payload, ...state.shareLinks];
      })
      .addCase(deactivateShareLink.fulfilled, (state, action) => {
        const link = state.shareLinks.find((l) => l.id === action.payload);
        if (link) link.isActive = false;
      });
  },
});

export default shareLinksSlice.reducer;
